import React from 'react';
import PageLayout from "../../components/page-layout";
import Grid from "@material-ui/core/Grid";
import ActionCard from "../../components/action-card";
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DevicesOverview from "../../components/devices-overview";
import {makeStyles} from "@material-ui/styles";

export default function Devices() {

    const classes = useStyles();

    return (
        <PageLayout pageTitle="دستگاه‌ها">
            <Grid container spacing={3} className={classes.actions}>
                <Grid item xs={12} sm={3}>
                    <ActionCard name="افزودن دستگاه‌های جدید" icon={<LibraryAddIcon/>}
                                path="/devices/insert"/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ActionCard name="دستگاه‌های ثبت شده" icon={<ListAltIcon/>}
                                path="/devices/inserted-devices"/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ActionCard name="مدل‌ها و برند‌ها" icon={<ListAltIcon/>}
                                path="/devices/models"/>
                </Grid>
            </Grid>
            <Grid container justifyContent="center">
                <Grid item xs={10} sm={6}>
                    <DevicesOverview/>
                </Grid>

            </Grid>

        </PageLayout>
    );
}


const useStyles = makeStyles(theme => ({
    actions: {
        marginBottom: theme.spacing(10)
    },
    upload: {
        marginTop: theme.spacing(3)
    },

}));
